(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/views/system-row-container.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/views/system-row-container.js');

'use strict';

svs.lotto.components.play.views.SystemRowContainer = Marionette.View.extend({
  className: 'numbergames-play-content grid-row padding-xs-h-1 padding-xs-bottom-2 padding-md-bottom-0 padding-md-h-2',
  regions: {
    andraChansenBannerRegion: '#andraChansenBannerRegion',
    boardContainerRegion: '#boardContainerRegion',
    systemSummaryRegion: '#systemSummaryRegion',
    andraChansenRowRegion: '#andraChansenRowRegion'
  },
  template(data) {
    return svs.lotto.components.play.templates.system_row_container(data);
  },
  onRender() {
    const ballRowSize = svs.core.detect.breakpoint.greaterThan('xs') ? 300 : 200;
    this.showChildView('boardContainerRegion', new svs.numbergames.game.views.BoardContainer({
      model: this.model,
      className: 'board-container-lotto board-container-lotto-system',
      boardButtonsView: svs.numbergames.game.views.BoardButtonsSystem
    }));
    this.showChildView('systemSummaryRegion', new svs.numbergames.game.views.SystemSummary({
      model: this.model,
      className: 'number-games-system-summary-lotto',
      ballRowType: svs.tur.ball.row.Lotto,
      ballRowSize
    }));
    this.showChildView('andraChansenRowRegion', new svs.lotto.components.play.views.AndraChansenRowBanner({
      model: this.model,
      className: 'andra-chansen-rows-region',
      ballRowSize,
      ballRowOptions: {
        classNames: ['margin-bottom-half']
      }
    }));
  }
});

 })(window);